import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import { useEffect, useState } from "react";
import HomePage from "./pages/HomePage"
import LoginPage from "./pages/LoginPage"
import RegisterChooseRole from "./pages/RegisterChooseRole"
import RegisterPeserta from './pages/RegisterPeserta';
import RegisterMitra from './pages/RegisterMitra';
import RegisterMentor from "./pages/RegisterMentor";
import ChangePassword from "./pages/ChangePassword"
import ProfilPeserta from "./pages/Profil/Peserta"
import DataPribadiPeserta from "./pages/Profil/Peserta/DataPribadi"
import MediaSosialPeserta from "./pages/Profil/Peserta/MediaSosial"
import KontakPribadiPeserta from "./pages/Profil/Peserta/KontakPribadi"
import DetailRekeningPeserta from "./pages/Profil/Peserta/DetailRekening"
import UploadFotoProfilPeserta from "./pages/Profil/Peserta/UploadFotoProfil"
import ProfilMentor from './pages/Profil/Mentor/Profil';
import ProfilMitra from './pages/Profil/Mitra/Profil';
import FormDataPribadiPeserta from "./pages/FormProfil/Peserta/DataPribadi"
import FormMediaSosialPeserta from "./pages/FormProfil/Peserta/MediaSosial"
import FormKontakPribadiPeserta from "./pages/FormProfil/Peserta/KontakPribadi"
import FormDetailRekeningPeserta from "./pages/FormProfil/Peserta/DetailRekening"
import FormProfilMitra from './pages/FormProfil/Mitra/Profil';
import FormProfilMentor from "./pages/FormProfil/Mentor/Profil"
import LihatDokumen from './pages/Dokumen/LihatDokumen';
import EditDokumen from './pages/Dokumen/EditDokumen';
import Lowongan from "./pages/Lowongan"
import DetailMitra from "./pages/DetailMitra"
import DetailLowongan from "./pages/DetailLowongan"
import LamarLowongan from "./pages/LamarLowongan"
import EditBuktiPembayaran from "./pages/BuktiPembayaran/EditBuktiPembayaran"
import LihatBuktiPembayaran from "./pages/BuktiPembayaran/LihatBuktiPembayaran"
import 'boxicons/css/boxicons.min.css';
import AppLayout from './components/layout/AppLayout';
import AppLayoutMitra from './components/layoutMitra/AppLayout';
import AppLayoutMentor from './components/layoutMentor/AppLayout';
import AppLayoutKegiatanku from "./components/layoutKegiatanku/AppLayaout";
import AppLayoutAdmin from './components/layoutAdmin/AppLayout';
import "bootstrap/dist/css/bootstrap.min.css";
import AuthService from "./services/auth.service"
import AdminPembayaran from "./pages/Admin/VerifikasiPembayaran";
import AdminProposal from "./pages/Admin/VerifikasiProposal";
import DetailPembayaran from "./pages/Admin/DetailPembayaran";
import DetailProposal from "./pages/Admin/DetailProposal";
import PartisipanAktif from "./pages/PartisipanAktif";
import DokumenPartisipan from "./pages/DokumenPartisipan";
import ProposalMitra from "./pages/Proposal/ListProposal";
import DetailProposalPage from "./pages/DetailProposalMitra";
import StatusPendaftaran from "./pages/StatusPendaftaran";
import FormProposal from "./pages/Proposal/FormProposal";
import EditProposal from "./pages/Proposal/EditProposal";
import FormRevisiProposal from "./pages/Admin/FormRevisiProposal";
import ItemTersimpan from "./pages/ItemTersimpan";
import EditLaporan from "./pages/Mentor/Laporan/EditLaporan";
import ListLaporanPeserta from "./pages/Mentor/Laporan/ListLaporanPeserta";
import FormTolakProposal from "./pages/Admin/FormPenolakanProposal";
import KegiatanAktif from "./pages/KegiatanAktif"
import FeedbackLaporan from "./pages/Mentor/FormFeedback";
import ListMentor from "./pages/ListMentor";
import MenteeManajemen from "./pages/Mentor/MenteeManagement";
import BuatLaporan from "./pages/KegiatanAktif/Create";
import ListMentee from "./pages/ListMentor/ListMentee";
import ListLaporanPesertaMentor from "./pages/ListMentor/ListLaporanPesertaMentor";



function App() {
  const [currentUser, setCurrentUser] = useState([]);
  const [peserta, setPeserta] = useState(false);
  const [mitra, setMitra] = useState(false);
  const [mentor, setMentor] = useState(false);
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
        setCurrentUser(user);
        setPeserta(user.roles.includes("Peserta"));
        setMitra(user.roles.includes("Mitra"));
        setMentor(user.roles.includes("Mentor"));
        setAdmin(user.roles.includes("Admin"));
    }
  }, [])

  return (
    <>
      <Router>
      
      <div className="App">
          <Routes>
              <Route path='/' element={<HomePage/>} />
              <Route exact path='/login' element={<LoginPage/>} />
              <Route exact path='/register' element={<RegisterChooseRole/>} />
              <Route exact path='/register/peserta' element={<RegisterPeserta/>} />
              <Route exact path='/register/mitra' element={<RegisterMitra/>} />

              {peserta &&
              <Route>
              <Route path='/peserta/' element={<AppLayout />}>
                <Route exact path='/peserta/change-password' element={<ChangePassword/>} />
                <Route path='/peserta/profile' index element={<ProfilPeserta/>} />
                <Route path='/peserta/profile/datapribadi/:id' element={<DataPribadiPeserta/>} />
                <Route path='/peserta/profile/mediasosial/:id' element={<MediaSosialPeserta/>} />
                <Route path='/peserta/profile/kontak/:id' element={<KontakPribadiPeserta/>} />
                <Route path='/peserta/profile/rekening/:id' element={<DetailRekeningPeserta/>} />
                <Route path='/peserta/profile/upload/foto/:id' element={<UploadFotoProfilPeserta/>} />
                <Route exact path='/peserta/dokumen/:id' element={<LihatDokumen/>} />
                <Route exact path='/peserta/dokumen/edit/:id' element={<EditDokumen/>} />
                <Route path='/peserta/item-tersimpan/:id' element={<ItemTersimpan/>} />
                <Route path='/peserta/profile/isi-datapribadi/:id' element={<FormDataPribadiPeserta/>} />
                <Route path='/peserta/profile/isi-mediasosial/:id' element={<FormMediaSosialPeserta/>} />
                <Route path='/peserta/profile/isi-kontak/:id' element={<FormKontakPribadiPeserta/>} />
                <Route path='/peserta/profile/isi-rekening/:id' element={<FormDetailRekeningPeserta/>} />
              </Route>
              <Route path='/peserta/kegiatanku/' element={<AppLayoutKegiatanku />}>
                <Route path='/peserta/kegiatanku/buktipembayaran/edit/:id' element={<EditBuktiPembayaran/>} />
                <Route path='/peserta/kegiatanku/buktipembayaran/:id' element={<LihatBuktiPembayaran/>} />
                <Route path='/peserta/kegiatanku/statuspendaftaran/:id' element={<StatusPendaftaran/>} />
                <Route path='/peserta/kegiatanku/kegiatanaktif/:id' element={<KegiatanAktif/>} />
                <Route path='/peserta/kegiatanku/kegiatanaktif/buatLaporan/:idPeserta/:id' element={<BuatLaporan/>} />
                <Route path='/peserta/kegiatanku/kegiatanaktif/editlaporan/:idPeserta/:id' element={<EditLaporan/>} />
              </Route>
              </Route>
              }

              {mentor &&
              <Route path='/mentor/' element={<AppLayoutMentor />}>
                <Route path='/mentor/profile/change-password' element={<ChangePassword/>} />
                <Route path='/mentor/profile/lihat/:id' element={<ProfilMentor/>} />
                <Route path='/mentor/profile/isi-profil/:id' element={<FormProfilMentor/>} />
                <Route path='/mentor/manajemenmentee/listlaporanpeserta/:idMentor/:id' element={<ListLaporanPeserta/>} />
                <Route path='/mentor/manajemenmentee/feedbacklaporan/:idLowonganPeserta/:id' element={<FeedbackLaporan/>} />
                <Route path='/mentor/manajemenmentee/list-mentee/:id' element={<MenteeManajemen/>} />
              </Route>
              }

              {admin && (
              <Route path='/admin/' element={<AppLayoutAdmin />}>
                <Route path='/admin/verifikasi/proposal' element={<AdminProposal/>} />
                <Route path='/admin/verifikasi/pembayaran' element={<AdminPembayaran/>} />
                <Route path='/admin/verifikasi/proposal/revisi/:id' element={<FormRevisiProposal/>} />
                <Route path='/admin/verifikasi/proposal/tolak/:id' element={<FormTolakProposal/>} />
                <Route path='/admin/detail/pembayaran/:id' element={<DetailPembayaran/>} />
                <Route path='/admin/detail/proposal/:id' element={<DetailProposal/>} />
              </Route>
              )}

              {mitra &&
              <Route path='/mitra/' element={<AppLayoutMitra />}>
                <Route exact path='/mitra/profile/change-password' element={<ChangePassword/>} />
                <Route path='/mitra/profile/lihat/:id' element={<ProfilMitra/>} />
                <Route path='/mitra/profile/isi-profil/:id' element={<FormProfilMitra/>} />
                <Route exact path='/mitra/profile/mentor/add/:id' element={<RegisterMentor/>} />
                <Route exact path='/mitra/profile/PartisipanAktif/:id' element={<PartisipanAktif/>} />
                <Route exact path='/mitra/profile/dokumenPartisipan/:id' element={<DokumenPartisipan/>} />
                <Route exact path='/mitra/profile/proposal' element={<ProposalMitra/>} />
                <Route exact path='/mitra/profile/proposal/form/:id' element={<FormProposal/>} />
                <Route exact path='/mitra/profile/proposal/detail/:id' element={<DetailProposalPage/>} />
                <Route path='/mitra/profile/mentor/listlaporanpeserta/:idMitra/:idMentor/:id' element={<ListLaporanPesertaMentor/>} />
                <Route exact path='/mitra/profile/editproposal/:id' element={<EditProposal/>} />
                <Route exact path='/mitra/profile/mentor/list-mentor/:id' element={<ListMentor/>} />
                <Route exact path='/mitra/profile/mentor/list-mentee/:idMentor/:id' element={<ListMentee/>} />
              </Route>
              }
              

              {!mitra && (
                <Route>
                  <Route exact path='/mitra/detail/:idPeserta/:id' element={<DetailMitra/>} />
                  <Route exact path='/lowongan' element={<Lowongan/>} />
                </Route>
              )}

              {peserta && (
                <Route>
                  <Route exact path="/lowongan/detail/:idPeserta/:id" element={<DetailLowongan/>} /> 
                  <Route exact path="/lowongan/lamar/:id" element={<LamarLowongan/>} /> 
                </Route>
              )}
              
            
          </Routes>
      </div>
      </Router>
      
    </>

  );
}

export default App;